export default __webpack_public_path__ + "static/media/mswhite.6673b9be.png";